export default "__VITE_ASSET__BpXT9bxe__"